<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M5.87,783.73l3.42,3.42l1.21-1.21l-3.42-3.42L5.87,783.73z M7.58,784.23L-7.79,799.6l1.21,1.21l15.38-15.38L7.58,784.23z
	 M2.43,793.25l-2.66-2.67l-1.21,1.21l2.66,2.67L2.43,793.25z M-9.5,799.06l3.42,3.42l1.21-1.21l-3.42-3.42L-9.5,799.06z"/>
</svg>

</template>